const NotRequiredIcon = (props: any) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="18"
        height="17"
        rx="5.5"
        stroke="#A4A4A4"
        strokeWidth="2"
      />
      <path
        d="M9.898 13.376L10.096 11.18L10.258 11.198L8.26 12.548L7.486 11.216L9.646 10.244L9.628 10.352L7.468 9.326L8.242 7.994L10.276 9.416L10.096 9.398L9.898 7.166H11.5L11.302 9.56L11.104 9.434L13.084 8.03L13.84 9.38L11.644 10.406V10.208L13.822 11.198L13.048 12.53L11.086 11.144L11.32 11.18L11.5 13.376H9.898Z"
        fill="#A4A4A4"
        strokeWidth="2"
      />
      <path
        d="M4 19L16 1"
        stroke="#A4A4A4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { NotRequiredIcon };
